"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var shared_values_1 = require("./shared-values");
var use_once_1 = require("./use-once");
exports.useEvent = function (eventType, callback) {
    var stream = shared_values_1.useSharedValue(shared_values_1.APP_EVENTS, eventType)[0];
    use_once_1.useOnce(function () {
        var sub = stream.subscribe(function (event) { return callback(event.payload); });
        return function () { return sub.unsubscribe(); };
    });
};
exports.useEventStream = function (eventType) {
    var stream = shared_values_1.useSharedValue(shared_values_1.APP_EVENTS, eventType)[0];
    return stream.pipe(operators_1.map(function (event) { return event.payload; }));
};
exports.useEventDispatch = function (event) {
    var stream = shared_values_1.useSharedValue(shared_values_1.APP_EVENTS, event)[0];
    return createEventDispatch(event, stream);
};
function createEventDispatch(event, stream) {
    return function (payload) {
        stream.next({
            type: event,
            payload: payload
        });
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLWV2ZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3VzZS1ldmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLDRDQUFtQztBQUNuQyxpREFBeUY7QUFFekYsdUNBQW1DO0FBRXRCLFFBQUEsUUFBUSxHQUFHLFVBQUksU0FBMEIsRUFBRSxRQUErQjtJQUM1RSxJQUFBLGlGQUFNLENBQW9EO0lBQ2pFLGtCQUFPLENBQUM7UUFDSixJQUFNLEdBQUcsR0FBRyxNQUFNLENBQUMsU0FBUyxDQUFDLFVBQUEsS0FBSyxJQUFJLE9BQUEsUUFBUSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsRUFBdkIsQ0FBdUIsQ0FBQyxDQUFDO1FBQy9ELE9BQU8sY0FBTSxPQUFBLEdBQUcsQ0FBQyxXQUFXLEVBQUUsRUFBakIsQ0FBaUIsQ0FBQztJQUNuQyxDQUFDLENBQUMsQ0FBQztBQUNQLENBQUMsQ0FBQztBQUVXLFFBQUEsY0FBYyxHQUFHLFVBQUksU0FBMEI7SUFDakQsSUFBQSxpRkFBTSxDQUFvRDtJQUNqRSxPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUMsZUFBRyxDQUFDLFVBQUEsS0FBSyxJQUFJLE9BQUEsS0FBSyxDQUFDLE9BQU8sRUFBYixDQUFhLENBQUMsQ0FBQyxDQUFDO0FBQ3BELENBQUMsQ0FBQztBQUVXLFFBQUEsZ0JBQWdCLEdBQUcsVUFBSSxLQUFzQjtJQUMvQyxJQUFBLDZFQUFNLENBQWdEO0lBQzdELE9BQU8sbUJBQW1CLENBQUMsS0FBSyxFQUFFLE1BQU0sQ0FBQyxDQUFDO0FBQzlDLENBQUMsQ0FBQztBQUVGLFNBQVMsbUJBQW1CLENBQUksS0FBc0IsRUFBRSxNQUF5QjtJQUM3RSxPQUFPLFVBQUMsT0FBVTtRQUNkLE1BQU0sQ0FBQyxJQUFJLENBQUM7WUFDUixJQUFJLEVBQUUsS0FBSztZQUNYLE9BQU8sU0FBQTtTQUNWLENBQUMsQ0FBQztJQUNQLENBQUMsQ0FBQztBQUNOLENBQUMifQ==